// 该部分用于规定补全调查员库列表内容的字段
// 不填充
export const notSupplement = ['recycleData', 'allotTasks', 'answer_pass_ratio', 'case_pass_ratio']

// 用 0 填充
export const zeroSupplement = [
  'score',
  'inspect_project',
  'report_case',
  'audit_case',
  'case_pass_ratio',
  'wj_project',
  'report_answer',
  'audit_answer',
  'answer_pass_ratio',
  'settle_project',
  'settle_amount'
]

// 该部分用于调查员详情页数据的存储
// 调查员基础信息
export const basicInfoColumns = [
  {
    label: '题干',
    value: 'title',
    align: 'center'
  },
  {
    label: '答案',
    value: 'answer',
    align: 'center'
  }
]

// 调查员执行问卷项目详情
export const wjProjectDetailColumns = [
  {
    label: '执行项目名称',
    value: 'projectName',
    align: 'left'
  },
  {
    label: '上报答卷数',
    value: 'reportAnswers',
    align: 'right'
  },
  {
    label: '审核答卷数',
    value: 'auditAnswers',
    align: 'right'
  },
  {
    label: '答卷审核通过率',
    value: 'answerPassRatio',
    align: 'left'
  },
  {
    label: '操作',
    value: 'operation',
    align: 'left'
  }
]

export const wjProjectDetailPage = {
  layout: 'total, prev, pager, next, jumper',
  currentPage: 1,
  pageSize: 10,
  total: 0
}

// 调查员费用结算记录详情
export const settleProjectDetailColumns = [
  {
    label: '项目名称',
    value: 'project_name',
    align: 'left',
    width: 365
  },
  {
    label: '结算金额(元)',
    value: 'amount',
    align: 'right',
    width: 120
  },
  {
    label: '操作',
    value: 'operation',
    align: 'left',
    width: 70
  }
]

export const settleProjectDetailPage = {
  layout: 'total, prev, pager, next, jumper',
  currentPage: 1,
  pageSize: 10,
  total: 0
}

// 调查员操作记录
export const operationRecordColumns = [
  {
    label: '操作事项',
    value: 'title',
    align: 'left',
    width: 146
  },
  {
    label: '修改前内容',
    value: 'oldAnswer',
    align: 'left',
    width: 98
  },
  {
    label: '修改后内容',
    value: 'newAnswer',
    align: 'left',
    width: 98
  },
  {
    label: '操作时间',
    value: 'editTime',
    align: 'left',
    width: 124
  },
  {
    label: '操作人',
    value: 'editorName',
    align: 'left',
    width: 60
  },
  {
    label: '操作人手机号码',
    value: 'editorPhone',
    align: 'left',
    width: 120
  }
]

export const operationRecordPage = {
  layout: 'total, prev, pager, next, jumper',
  currentPage: 1,
  pageSize: 10,
  total: 0
}
